import $ from "jquery";
//const $ = require( "jquery" )( window );

export default {
    /**
     * Check if current date is within the valid range
     * @param {string} startDate - Start date in format "YYYY-MM-DD"
     * @param {string} endDate - End date in format "YYYY-MM-DD"
     * @returns {boolean} - True if current date is within range
     */
    isCurrentDateActive(startDate, endDate) {
        // Safety check: if no dates provided, return false
        if (!startDate || !endDate) {
            console.warn('[functions] Sale price missing dates, returning false');
            return false;
        }
        
        console.log('[functions] Checking date validity:', {
            startDate,
            endDate
        });

        // Get current date (midnight for consistent comparison)
        let currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        
        // Parse start date (midnight - beginning of day)
        let effectiveDate = new Date(startDate);
        effectiveDate.setHours(0, 0, 0, 0);
        
        // Parse end date (end of day - 23:59:59.999)
        let terminationDate = new Date(endDate);
        terminationDate.setHours(23, 59, 59, 999);

        const isValid = currentDate >= effectiveDate && currentDate <= terminationDate;

        console.log('[functions] Date check result:', {
            today: currentDate.toISOString().split('T')[0],
            effectiveDate: startDate,
            terminationDate: endDate,
            isValid
        });

        return isValid;
    },
    /**
     * Check if tier has valid sale price with active dates
     * @param {Object} tierLine - Tier price object
     * @returns {boolean} - True if sale price is valid and active
     */
    isValidatedSpecialPrice(tierLine) {
        // Check if tier object exists
        if (!tierLine || typeof tierLine !== 'object') {
            console.warn('[functions] Invalid tierLine object');
            return false;
        }
        
        // Check if sale_price exists
        if (!Object.prototype.hasOwnProperty.call(tierLine, 'sale_price')) {
            return false;
        }
        
        // Check if dates exist
        if (!Object.prototype.hasOwnProperty.call(tierLine, 'sale_price_effectivedate') ||
            !Object.prototype.hasOwnProperty.call(tierLine, 'sale_price_terminationdate')) {
            console.warn('[functions] Sale price missing dates, using regular price', tierLine);
            return false;
        }
        
        // Check if current date is within valid range
        const isActiveDate = this.isCurrentDateActive(
            tierLine['sale_price_effectivedate'],
            tierLine['sale_price_terminationdate']
        );
        
        return isActiveDate;
    },
    getStepText() {
        let stepThreeText = "Add your imprint here. You can choose to add Text, an Image or both!" +
            " To start, choose where you would like to imprint your product and fill in the required info.";
        if(window.PXUTheme.theme_settings.project_store_name == 'comda') {
            stepThreeText = "Add your imprint here. You can choose to add Text," +
                " an Image or both! To start, choose where you would like to imprint your product and fill in the required info." +
                " You can add one imprint per product online; to add additional imprints please contact us at 800-387-7702.";
        }
        return stepThreeText;
    },
    getB2BPriceForTier(tier, b2bTiers) {
        if (!b2bTiers) return null;
        const entry = b2bTiers.find(t => Number(t.QtyMin) === Number(tier.QtyMin));
        return entry ? Number(entry.price) : null;
    },
    isCheckboxChecked(jqueryPath = '') {
        let isChecked = false;
        let checkboxes = $(jqueryPath);

        if(jqueryPath) {
            for (const checkbox of checkboxes) {
                /*if(checkbox.checked && !checkbox.disabled) {*/
                if(checkbox.checked) {
                    isChecked = true;
                }
            }
        }
        return isChecked;
    }
};